import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const DomainBlacklisted = withSuspense(lazy(() => import('./domain-blacklist-search')));
export default DomainBlacklisted;
